import { StateCreator } from 'zustand';
import { Store } from 'store';
import { ToastParams } from 'components/toast';

const DEFAULT_TOAST: ToastParams = {
  show: false,
  message: '',
  dismissesIn: 5,
  dissmissLabel: 'Закрыть',
} as const;

export const enum AuthBottomSheetState {
  inputPhone,
  inputCode,
  inputName,
}
export interface UISlice {
  globalLoader: boolean;
  toggleGlobalLoader: () => void;

  isAuthBottomSheetOpen: boolean;
  openAuthBottomSheet: () => void;
  closeAuthBottomSheet: () => void;

  authBottomSheetState: AuthBottomSheetState;
  proceedToAuthInputCode: () => void;
  proceedToAuthInputName: () => void;

  toastParams: ToastParams;
  showToast: (
    params: Pick<ToastParams, 'message' | 'onDismissClick'> &
      Partial<Pick<ToastParams, 'dismissesIn' | 'dissmissLabel'>>,
  ) => void;
  dismissToast: () => void;

  forceAuthorize: () => boolean;

  tabFavoritesSelected: number;
  setTabFavoriteSelected: (value: number) => void;

  keyBoardHeight: number;
  setKeyBoardHeight: (value: number) => void;

  isShowKeyBoardHeight: boolean;
  setIsShowKeyBoardHeight: (value: boolean) => void;

  screenPadding: number;
  setScreenPadding: (value: number) => void;
}

const createUISlice: StateCreator<Store, [['zustand/immer', never]], [], UISlice> = (set, get) => ({
  globalLoader: false,
  toggleGlobalLoader: () => set((s) => ({ globalLoader: !s.globalLoader })),

  tabFavoritesSelected: 0,
  setTabFavoriteSelected: (value) => set({ tabFavoritesSelected: value }),

  isAuthBottomSheetOpen: false,
  openAuthBottomSheet: () => set({ isAuthBottomSheetOpen: true }),
  closeAuthBottomSheet: () =>
    set({
      isAuthBottomSheetOpen: false,
      authPhone: '',
      authBottomSheetState: AuthBottomSheetState.inputPhone,
    }),

  authBottomSheetState: AuthBottomSheetState.inputPhone,

  proceedToAuthInputCode: () => set({ authBottomSheetState: AuthBottomSheetState.inputCode }),

  proceedToAuthInputName: () => {
    const store = get();

    const username = store.user?.name;
    if (!username) {
      set(() => ({ authBottomSheetState: AuthBottomSheetState.inputName }));
    } else {
      store.closeAuthBottomSheet();
    }
  },

  toastParams: DEFAULT_TOAST,
  showToast: (params) => set({ toastParams: { ...DEFAULT_TOAST, show: true, ...params } }),
  dismissToast: () => set({ toastParams: DEFAULT_TOAST }),

  forceAuthorize: () => {
    const { user, openAuthBottomSheet } = get();

    if (user) return true;

    openAuthBottomSheet();
    return false;
  },

  keyBoardHeight: 0,
  setKeyBoardHeight: (value) => set({ keyBoardHeight: value }),

  isShowKeyBoardHeight: false,
  setIsShowKeyBoardHeight: (value) => {
    const setValue = () => {
      set({ isShowKeyBoardHeight: value });
    };
    if (value) {
      setTimeout(() => {
        setValue();
      }, 400);
      return;
    }
    setValue();
  },

  screenPadding: 0,
  setScreenPadding: (value) => set({ screenPadding: value }),
});

export default createUISlice;
